// Tempo evaluators. Tempo decides *when* and *which* active skill to cast
// given the candidate set, the cooldown situation, and the rule.
//
// The actual skill list will be wired in Step 8 (sample skills). For Phase 1
// MVP we work against a minimal CandidateSkill shape so this module can be
// unit-tested in isolation.
//
// MP は廃止（ADR 0003 §2.3.1）。tempo_conserve は戦況（敵の総 HP 比）で判断する。
/** Below this average enemy-HP ratio tempo_conserve allows active fire. */
const CONSERVE_ENEMY_HP_THRESHOLD = 0.7;
const EXECUTE_HP_THRESHOLD = 0.3;
/**
 * Pick the best skill to cast this tick under the given rule, or return null
 * if Tempo wants to hold fire.
 */
export function pickSkill(self, state, rule, candidates, targetId, _rng) {
    const ready = candidates.filter((c) => c.ready);
    if (ready.length === 0)
        return null;
    const target = targetId !== null ? state.entities.find((e) => e.id === targetId) : undefined;
    const targetHpPct = target ? target.hp / target.hpMax : 1;
    switch (rule) {
        case 'tempo_burst':
            // Fire whatever's strongest as soon as it's available.
            return highestPower(ready);
        case 'tempo_conserve': {
            // 戦況ベースの温存: 敵の平均 HP 比が閾値以上なら通常攻撃のみ、
            // 削れている / ボスやエリートが残るなら active を解禁する。
            const enemies = state.entities.filter((e) => e.side !== self.side && e.hp > 0);
            if (enemies.length === 0)
                return null;
            const avgHpPct = enemies.reduce((sum, e) => sum + e.hp / Math.max(1, e.hpMax), 0) / enemies.length;
            if (avgHpPct >= CONSERVE_ENEMY_HP_THRESHOLD) {
                return null;
            }
            return highestPower(ready);
        }
        case 'tempo_conditional': {
            // Save big skills for crowded situations or low-HP targets.
            const enemies = state.entities.filter((e) => e.side !== self.side && e.hp > 0).length;
            if (enemies >= 3 || targetHpPct < 0.6) {
                return highestPower(ready);
            }
            return null;
        }
        case 'tempo_executor':
            // Only fire when target is below the execute threshold.
            if (targetHpPct < EXECUTE_HP_THRESHOLD) {
                const exec = ready.filter((c) => c.tags.has('execute'));
                return exec.length > 0 ? highestPower(exec) : highestPower(ready);
            }
            return null;
        case 'tempo_dot_focus': {
            // Prefer skills tagged as dot first, then fall back to highest power.
            const dot = ready.filter((c) => c.tags.has('dot'));
            if (dot.length > 0)
                return highestPower(dot);
            return highestPower(ready);
        }
        case 'tempo_ult_focus': {
            // Hold lesser skills if the ultimate will come up soon. If it's ready
            // right now, use it; otherwise wait unless target is below execute HP.
            const ult = ready.find((c) => c.tags.has('ultimate'));
            if (ult)
                return ult.id;
            if (targetHpPct < 0.5)
                return highestPower(ready);
            return null;
        }
    }
}
function highestPower(list) {
    if (list.length === 0)
        return null;
    let best = list[0];
    for (let i = 1; i < list.length; i++) {
        if (list[i].power > best.power)
            best = list[i];
    }
    return best.id;
}
//# sourceMappingURL=tempo.js.map